/**
 * Report prompt template + builder — Atlas Chat Reports.
 *
 * `buildReportPrompt(filters)` embeds the modal's selections into the template
 * below. Every `{{placeholder}}` maps to one `filters` key via FIELD_MAP;
 * multi-select dimensions are joined with ", " and empty ones pass through
 * blank (the template's own instructions tell the model to ignore empties).
 *
 * Keep the placeholder set in sync with the modal fields (FilterStep.jsx).
 */

export const REPORT_PROMPT_TEMPLATE = `Analyze the following industry and identify companies that match the provided criteria.

Industry: {{industry}}

Criteria Filters (Must match all criteria):
IPO Status: {{ipo_status}}
Funding Type: {{funding_type}}
Total Funding Raised: {{total_funding}}
Revenue Range: {{revenue_range}}
Number of Employees: {{employee_range}}

Additional Details: {{additional_details}}

Instructions:

- Apply only filters that contain values.
- Ignore any filter that is empty or null.
- Prioritize companies that best match the provided criteria.
- Search for recent industry developments, company news, funding activity, growth signals, hiring trends, product launches, partnerships, acquisitions, and market movements.
- Never ask for any clarification or confirmation you are a powerful researcher can figure out all the confusion.

For each company provide the detail information.
After listing the companies, provide:

- Industry Overview
- Major Market Trends (US and Ohio)
- Key Risks
- Emerging Opportunities
- News of industry with in 12 months`;

// placeholder token -> filters key
const FIELD_MAP = {
  industry: 'sectors',
  ipo_status: 'ipoStatus',
  funding_type: 'fundingType',
  total_funding: 'fundingTotal',
  revenue_range: 'revenueRange',
  employee_range: 'numEmployees',
  additional_details: 'context',
};

const valueFor = (filters, key) => {
  const v = filters[key];
  if (Array.isArray(v)) return v.join(', ');
  return typeof v === 'string' ? v.trim() : '';
};

export const buildReportPrompt = (filters = {}) =>
  REPORT_PROMPT_TEMPLATE.replace(/\{\{(\w+)\}\}/g, (_, token) => {
    const key = FIELD_MAP[token];
    return key ? valueFor(filters, key) : '';
  });
